import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const seriaPlusSelector = createSelector(getFilters, state => state.seriaPlus);
